import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography
} from '@mui/material';
import { ChromePicker } from 'react-color';
import { ThemeProvider } from '@mui/material/styles';
import menuTheme from '../menuTheme';

const EditStyleDialog = ({ open, onClose, style, onSave }) => {
  const [tempStyle, setTempStyle] = React.useState(style);
  const [selectedField, setSelectedField] = React.useState(null);

  React.useEffect(() => {
    setTempStyle(style);
  }, [style]);


  const ColorPickerStyles = () => (
    <style>
      {`
        .chrome-picker {
          width: 100% !important;
          margin-top: 0px !important;
          box-shadow: none !important;
          border: 1px solid #e0e0e0 !important;
        }
      `}
    </style>
  );
  

  const handleColorChange = (color) => {
    if (!selectedField) return;
    setTempStyle(prev => ({
      ...prev,
      [selectedField]: color.rgb ? `rgb(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b})` : color.hex
    }));
  };

  const colorFields = [
    { key: 'catalogBackgroundColor', label: 'Color de fondo del catálogo' },
    { key: 'headerBackgroundColor', label: 'Color de fondo del encabezado' },
    { key: 'primaryTextColor', label: 'Color de texto principal' },
    { key: 'secondaryTextColor', label: 'Color de texto secundario' },
    { key: 'nameColor', label: 'Color del nombre' },
    { key: 'descriptionColor', label: 'Color de la descripción' }
  ];

  return (
    <ThemeProvider theme={menuTheme}>
        <ColorPickerStyles />
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Editar estilo general</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {colorFields.map((field, index) => (
            <React.Fragment key={field.key}>
              <Box
                onClick={() => setSelectedField(field.key === selectedField ? null : field.key)}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  p: 1,
                  cursor: 'pointer',
                  bgcolor: selectedField === field.key ? 'rgba(0, 0, 0, 0.04)' : 'transparent',
                  borderRadius: 1,
                  '&:hover': {
                    bgcolor: 'rgba(0, 0, 0, 0.04)'
                  }
                }}
              >
                <Box
                  sx={{
                    width: 24,
                    height: 24,
                    borderRadius: '4px',
                    bgcolor: tempStyle[field.key],
                    border: '1px solid rgba(0, 0, 0, 0.1)'
                  }}
                />
                <Typography variant="body2">{field.label}</Typography>
              </Box>
              
              {selectedField === field.key && (
                <Box sx={{ p: 2, bgcolor: 'grey.50', borderRadius: 1, mb: 1 }}>
                  <ChromePicker
                    color={tempStyle[field.key]}
                    onChange={handleColorChange}
                    styles={{ default: { picker: { width: '100%' } } }}
                  />
                </Box>
              )}
            </React.Fragment>
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={() => onSave({
            catalogBackgroundColor: 'rgb(233, 233, 233)',
            headerBackgroundColor: 'rgb(255, 255, 255)',
            primaryTextColor: '#000000',
            secondaryTextColor: '#6c757d',
            nameColor: '#000000',
            descriptionColor: '#000000'
          })}
          color="warning"
        >
          Restaurar predeterminados
        </Button>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={() => onSave(tempStyle)} variant="contained">
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
    </ThemeProvider>
  );
};

export default EditStyleDialog; 